var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Mixins, Prop, Component, Watch } from 'vue-property-decorator';
import TextInputRow from '@/common/components/TextInputRow.vue';
import { sanitize } from '@/common/utils/stringUtilities';
import TooltipIcon from '@/common/components/TooltipIcon.vue';
import { Focusable } from '@/common/mixins/Focusable';
var AddTargetGroupDialog = /** @class */ (function (_super) {
    __extends(AddTargetGroupDialog, _super);
    function AddTargetGroupDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // This prevents focus returning to the modal-triggering button as it is preferred that focus moves to
        // the newly created target group and remains there
        _this.nonExistentFocusTargetForClose = "nonExistentFocusTargetForClose123";
        _this.targetGroupName = "";
        _this.selectedGroups = [];
        return _this;
    }
    AddTargetGroupDialog.prototype.onChange = function (value) {
        if (value) {
            this.targetGroupName = "";
        }
    };
    Object.defineProperty(AddTargetGroupDialog.prototype, "targetGroupValue", {
        get: function () {
            return this.targetGroupName;
        },
        set: function (newValue) {
            this.targetGroupName = sanitize(newValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddTargetGroupDialog.prototype, "hasTargetGroups", {
        get: function () {
            return this.targetGroups.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddTargetGroupDialog.prototype, "maxSelected", {
        get: function () {
            return this.max ? this.targetGroupCount + this.selectedGroups.length >= this.max : false;
        },
        enumerable: false,
        configurable: true
    });
    AddTargetGroupDialog.prototype.checkboxDisabled = function (option) {
        return !this.selectedGroups.includes(option) && this.maxSelected;
    };
    Object.defineProperty(AddTargetGroupDialog.prototype, "sortedTargetGroups", {
        get: function () {
            return this.targetGroups.sort(this.byNameAsc);
        },
        enumerable: false,
        configurable: true
    });
    AddTargetGroupDialog.prototype.byNameAsc = function (a, b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        if (a.name == b.name)
            return 0;
    };
    AddTargetGroupDialog.prototype.getInputId = function (targetGroup) {
        return "cb_" + targetGroup.id;
    };
    AddTargetGroupDialog.prototype.confirm = function () {
        this.emitValues();
        this.cleanAndClose();
    };
    AddTargetGroupDialog.prototype.emitValues = function () {
        var e_1, _a;
        var name = this.targetGroupName;
        if (name && name.length > 0) {
            var match = this.sortedTargetGroups
                .find(function (group) { return group.name.toLowerCase() == name.toLowerCase(); });
            if (match) {
                this.$emit('select', match);
            }
            else {
                this.$emit('add', name);
            }
        }
        try {
            for (var _b = __values(this.selectedGroups), _c = _b.next(); !_c.done; _c = _b.next()) {
                var selected = _c.value;
                this.$emit('select', selected);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AddTargetGroupDialog.prototype.cleanAndClose = function () {
        this.clear();
        this.$bvModal.hide(this.id);
    };
    AddTargetGroupDialog.prototype.clear = function () {
        this.targetGroupName = "";
        this.selectedGroups = [];
    };
    AddTargetGroupDialog.prototype.focus = function () {
        if (this.sortedTargetGroups && this.sortedTargetGroups.length > 0) {
            var targetId = this.getInputId(this.sortedTargetGroups[0]);
            this.focusOnComponentId(targetId);
        }
        else {
            this.focusOnComponentId(this.id + '-add');
        }
    };
    __decorate([
        Prop({ type: String, required: false, default: "targetGroup" }),
        __metadata("design:type", String)
    ], AddTargetGroupDialog.prototype, "id", void 0);
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], AddTargetGroupDialog.prototype, "targetGroups", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], AddTargetGroupDialog.prototype, "max", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], AddTargetGroupDialog.prototype, "targetGroupCount", void 0);
    __decorate([
        Watch("maxSelected"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AddTargetGroupDialog.prototype, "onChange", null);
    AddTargetGroupDialog = __decorate([
        Component({
            name: 'AddTargetGroupDialog',
            components: {
                TextInputRow: TextInputRow,
                TooltipIcon: TooltipIcon
            }
        })
    ], AddTargetGroupDialog);
    return AddTargetGroupDialog;
}(Mixins(Focusable)));
export default AddTargetGroupDialog;
